

import { validations } from './validations'


export const libLang = {
	validations
}
